import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Room } from '@shared/base-search-bar/entities/room.entities';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import {
  selectGuestsPerRoomAction, addRoomAction, deleteRoomAction, resetGuestsPerRoomAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';
import { TravelerTypes } from '@pax/entities/traveler-info';

export interface GuestsPerRoomState extends EntityState<Room> {}

export const guestsPerRoomAdapter: EntityAdapter<Room> = createEntityAdapter<Room>();
export const initialGuestsPerRoomState: GuestsPerRoomState = guestsPerRoomAdapter.getInitialState({
  ids: [0],
  entities: {
    0: {
      id: 0,
      [TravelerTypes.ADULTS]: 2,
      [TravelerTypes.CHILDREN]: 0,
      childrenAges: []
    }
  }
});

const reducer = createReducer(
  initialGuestsPerRoomState,
  on(resetGuestsPerRoomAction, () => initialGuestsPerRoomState),
  on(selectGuestsPerRoomAction, (state, { guestsPerRoom }) => {
    const { id } = guestsPerRoom;
    return guestsPerRoomAdapter.updateOne(
      {
        id,
        changes: guestsPerRoom
      },
      state
    );
  }),
  on(addRoomAction, (state, { room }) => {
    return guestsPerRoomAdapter.addOne(
      room,
      state
    );
  }),
  on(deleteRoomAction, (state, { index }) => {
    return guestsPerRoomAdapter.removeOne(index, state);
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => {
    return data ? data.guestsPerRoomState : initialGuestsPerRoomState;
  })
);

export function guestsPerRoomReducer(state: GuestsPerRoomState, action: Action): GuestsPerRoomState {
  return reducer(state, action);
}
